import $ from 'jquery'
import DateFilter from '@/components/date-filter';

export default {
    name: 'facture-proforma',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            months: [
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            is_empty: false,
            is_loading: true,

            fields: [
                'date', { key: 'ref', label: 'Référence' }, { key: 'patient', label: 'Patient' },
                { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: 20,
            print_per_page: -1,
            currentPage: 1,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.getListeFactureProforma(data)
        },

        // curr_month() {
        //     if (this.curr_month['id'] > 0) {
        //         this.type_period = 1
        //         this.period = this.curr_month['id']
        //         var data = {
        //             type_period: this.type_period,
        //             period: this.period
        //         }
        //         this.getListeFactureProforma(data)
        //     }
        // },

        // filter_date() {
        //     this.type_period = 2
        //     this.period = this.filter_date
        //     var data = {
        //         type_period: this.type_period,
        //         period: this.period
        //     }
        //     this.getListeFactureProforma(data)
        // }
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        facture_proformas() {
            return this.$store.getters['facture_proformas']
        },

        rows() {
            return this.facture_proformas.length
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.date.getMonth()]
    },

    methods: {
        getListeFactureProforma(data) {
            this.is_loading = true

            this.$store.dispatch('getFactureProforma', data).then(() => {
                if (this.facture_proformas.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        refreshFactureProforma() {
            this.getListeFactureProforma(this.current_date_filter)
        },

        setToDelete(c) {
            this.to_be_deleted = {
                id: c.id,
                libelle: c.ref
            }
        },

        selectPatient(data) {
            const selected_patient = {
                id: data.patient_id,
                nom: data.patient.patient,
                nom_patient: data.patient.patient,
                prenoms: "",
                sexe: data.patient.sexe,
                telephone_mobile: data.patient.telephone,
                age: data.patient.age,
                ref_fpro: data.ref,
                user: data.user,
                num_dossier: data.patient.code
            }
            this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);

            this.$router.push({ path: '/ventes/facture-proforma/'+data.id })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteFactureProforma', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Facture supprimée avec succès")
                    this.refreshFactureProforma()

                    this.is_confirm = false
                    this.$refs.del_fpro.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },

        filterByDate(date) {
            this.selected_operations = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeFactureProforma(data)
        },
    }
}